import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import useCreateJob from '../Jobs/useCreateJob';
import { CmonJobInstanceCommand } from '../../services/cmon/models/CmonJobInstance';
import CcCluster from '../../services/models/CcCluster';
import JobButton from '../Jobs/JobButton';

export default RefreshClusterConfigButton;
export type RefreshClusterConfigButtonProps = ButtonProps & {
    cluster: CcCluster;
    onFinish?: () => void;
};

function RefreshClusterConfigButton({
    cluster,
    onFinish,
    ...rest
}: RefreshClusterConfigButtonProps) {
    const { send, loading } = useCreateJob({
        clusterId: cluster.clusterId,
        title: 'Refresh cluster config',
        command: CmonJobInstanceCommand.IMPORT_CONFIG,
    });
    const handleRefresh: ButtonProps['onClick'] = async () => {
        await send({ clusterId: cluster.clusterId });
    };
    return (
        <JobButton
            type="primary"
            size="middle"
            command={CmonJobInstanceCommand.IMPORT_CONFIG}
            clusterId={cluster.clusterId}
            clusterType={cluster.clusterType}
            onClick={handleRefresh}
            onFinish={onFinish}
            loading={loading}
            {...rest}
        >
            Refresh config
        </JobButton>
    );
}
